<template>
  <div
    class="flex items-center text-sm gap-1"
    :class="color"
  >
    <span class="iconify svg--circle-full text-xxs m-1" />

    {{ $t(`${stockInformation}`, {stockCount: stockCount}) }}
  </div>
</template>
<script lang="ts">


import { hasLowStock } from '~~/helpers/product/getLowStock';
import { IN_STOCK, LOW_STOCK, SOLD_OUT, AVAILABLE_SOON } from '~~/constants/lowStockLimits';

export default defineComponent({
  name: 'StockInformation',
  props: {
    fullProductPrice: {
      type: Number,
      default: null,
    },
    stockCount: {
      type: Number,
      required: true,
    },
    isInStock: {
      type: Boolean,
      required: true,
    },
    isTestProduct: {
      type: Boolean,
      required: true,
    },
  },
  setup(props) {

    const { countryCode } = useLocalization();

    const isLowStock = computed(() => hasLowStock(countryCode.value, props.fullProductPrice, props.stockCount));
    const inStockInfo = computed(() => isLowStock.value ? LOW_STOCK : IN_STOCK);

    const stockInformation = computed(() => {

      if (props.isTestProduct) {

        return AVAILABLE_SOON;
      
      } else if (!props.isInStock) {

        return SOLD_OUT;
      
      } else {

        return inStockInfo.value;
      
      }
    
    });

    const color = computed(() => {

      if (
        stockInformation.value === AVAILABLE_SOON ||
        stockInformation.value === SOLD_OUT
      ) {

        return 'text-EXPONDO-grey-60';
      
      } else if (stockInformation.value === LOW_STOCK) {

        return 'text-EXPONDO-red';
      
      } else {

        return 'text-EXPONDO-green';
      
      }
    
    });

    return {
      stockInformation,
      color,
    };
  
  },
});

</script>
